<!--  -->
<template>
  <div class="footer">
    <div class="footer-wrap main_w">
      <div class="hd" v-if="footerType">
        <div class="footer-nav">
          <div
            class="nav-box"
            v-for="(item, i) in introData"
            :key="i"
            @click="goTo(item.url)"
          >
            <span>{{ item.name }}</span>
            <div></div>
          </div>
        </div>
        <div class="footer-ewm">
          <img src="../../assets/images/home_weixin.png" alt="" />
          <img src="../../assets/images/home_weibo.png" alt="" />
        </div>
      </div>
         <div class="bd">
        <div class="copyright" >
          <p>
            武汉掌通宝网络科技有限公司版权所有&nbsp;&nbsp;&nbsp;&nbsp;<a
              href="tel:400-099-3331"
              >客服电话：400-099-3331</a
            >
          </p>
          <p class="clearfix">
            <a href="http://beian.miit.gov.cn/" target="_blank"
              >鄂ICP备16003438号-1</a
            >&nbsp;&nbsp;&nbsp;&nbsp;<a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42010202002598"
              ><img
                class="record-icon"
                src="../../assets/images/record-icon.png"
              /><span>&nbsp;鄂公网安备42010202002598号</span></a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: "ztbFooter",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    footerType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    //这里存放数据
    return {
      introData: [
        {
          name: "公司历史",
          url: "/pages/page/about.html#/history",
        },
        {
          name: "公司使命",
          url: "/pages/page/about.html#/mission",
        },
        {
          name: "公司前景",
          url: "/pages/page/about.html#/perspective",
        },
        {
          name: "公司环境",
          url: "/pages/page/about.html#/environment",
        },
        {
          name: "公司规模",
          url: "/pages/page/about.html#/scale",
        },
        {
          name: "公司文化",
          url: "/pages/page/about.html#/culture",
        },
        {
          name: "联系我们",
          url: "/pages/page/about.html#/service",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    goTo(url) {
      window.location.href = this.$url + url;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style  lang='less'>
//@import url(); 引入公共css类
.footer {
  padding: 65px 0 40px 0;
  .footer-wrap {
    margin: 0 auto;
    color: #9b9b9b;
    .hd {
      padding: 0 30px;
      display: flex;
      justify-content: space-around;
      .footer-nav {
        display: flex;
        // justify-content: space-between;

        font-size: 20px;
        // color: #fff;
        cursor: pointer;
        .nav-box {
          display: flex;
          align-items: center;
          div {
            width: 1px;
            height: 20px;
            background:#9b9b9b;
            margin: 0 15px;
          }
        }
        .nav-box:last-child div {
          display: none;
        }
      }
      .footer-ewm {
        img {
          width: 40px;
          height: 40px;
        }
      }
      .footer-ewm img:last-child {
        margin-left: 20px;
      }
    }
    .bd {
      .copyright {
        padding-top: 18px;
        font-size: 18px;
        a {
          color:#9b9b9b;
        }
        a:link {
          text-decoration: none;
        }
        a:visited {
          text-decoration: none;
        }
        a:hover {
          text-decoration: none;
        }
        a:active {
          text-decoration: none;
        }
        p:last-child {
          padding-top: 16px;
        }
      }
    }
  }
}

</style>